import React, { useRef } from "react"
import PropTypes from "prop-types"
import { useFocusMode } from "hooks/use-focus-mode"
import { motion } from "framer-motion"

export function FocusModeSlideOut({ mode, className, style = {}, children }) {
  const { inFocusMode, animate } = useFocusMode(state => ({
    inFocusMode: state.inFocusMode,
    animate: state.animate
  }))

  const ref = useRef()

  let offset = 0
  if (inFocusMode) {
    offset = ["top", "bottom"].includes(mode)
      ? ref.current.offsetHeight
      : ref.current.offsetWidth
  }

  const variants = {
    focused: {
      [mode]: -offset,
      opacity: 0
    },
    normal: {
      [mode]: 0,
      opacity: 1
    }
  }

  return (
    <motion.div
      ref={ref}
      layout="position"
      className={className}
      initial={false}
      style={{
        ...style,
        position: inFocusMode ? "fixed" : undefined
      }}
      animate={inFocusMode ? "focused" : "normal"}
      variants={variants}
      transition={
        animate ? { duration: 0.24, ease: "easeOut" } : { duration: 0 }
      }
    >
      {children}
    </motion.div>
  )
}

FocusModeSlideOut.propTypes = {
  mode: PropTypes.oneOf(["top", "bottom", "left", "right"]).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  disableLayoutAnimation: PropTypes.bool
}
